<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p>I would like to thank Kate Larder, author of <em>Shut Up He Explained: The Memoir of a Blacklisted Kid</em>, for her mentorship and Stacey Donovan, author of <em>Forbidden Zone</em> and <em>Dive</em>, for her editorial contributions.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?12ba15f8